import type { ColumnsType, AnyObject } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

import { ProgressBar } from "app/components/React/ProgressBar/ProgressBar";
import { NO_DATA_SIGN } from "app/filters/const";
import { translate } from "app/filters/i18nFilter";

import { SearchOverviewTexts } from "../../texts";
import { CellWithLeftPadding } from "../OrganicPaidTable/styledComponents";
import { renderChangeCell, renderDomainCell } from "../TableCells/tableCells";

import { SearchTrafficColumnWrapper, PercentageValue } from "./styledComponent";

const { carbon } = colorsPalettes;

export const getSearchTrafficColumns = (): ColumnsType<AnyObject> =>
    [
        {
            title: <CellWithLeftPadding>{translate("analysis.source.search.overview.domain")}</CellWithLeftPadding>,
            dataIndex: "domain",
            width: 140,
            render: renderDomainCell,
        },
        {
            title: translate(SearchOverviewTexts.searchTrafficTitle),
            dataIndex: "searchTraffic",
            width: 92,
            render: (searchTraffic: { formattedValue: string; progressBarValue: number; color: string }) => {
                if (!searchTraffic) {
                    return NO_DATA_SIGN;
                }
                const { formattedValue, progressBarValue, color } = searchTraffic;
                return (
                    <SearchTrafficColumnWrapper>
                        {formattedValue ? <PercentageValue>{formattedValue}</PercentageValue> : NO_DATA_SIGN}
                        <ProgressBar
                            width={progressBarValue}
                            className="u-full-width"
                            isCompare={true}
                            height={8}
                            innerColor={color}
                            backgroundColor={carbon[50]}
                        />
                    </SearchTrafficColumnWrapper>
                );
            },
        },
        {
            title: translate(SearchOverviewTexts.yoyChange),
            dataIndex: "yoyChange",
            width: 83,
            align: "right",
            render: (change) => renderChangeCell(change),
        },
        {
            title: translate("analysis.source.search.overview.widgets.oftotaltraffic"),
            dataIndex: "percentageOf",
            width: 114,
            align: "right",
            render: (percentageOf: string) => (percentageOf ? <div>{percentageOf}</div> : NO_DATA_SIGN),
        },
    ] as ColumnsType<AnyObject>;
